import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { OpponentsApiService } from 'src/app/core/services/api/opponents-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Opponent } from '../../models/data/opponent';

@Component({
  selector: 'app-opponent-create-edit',
  templateUrl: './opponent-create-edit.component.html',
  styleUrls: ['./opponent-create-edit.component.scss']
})
export class OpponentCreateEditComponent implements OnInit {
  public opponent: Opponent;
  public cities = cities;
  public countries = countries;

  @ViewChild('opponentsModal') opponentsModal;
  @Output() submit: EventEmitter<Opponent> = new EventEmitter<Opponent>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: OpponentsApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(opponent: Opponent) {
    this.opponent = Object.assign(new Opponent(), opponent);
    this.modalRef = this.modalService.open(this.opponentsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.opponent.id) {
      this.spinner.show();
      this.api.updateOpponent(this.opponent).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createOpponent(this.opponent).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}

